var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger",class:{'crossed':_vm.value},on:{"click":function($event){return _vm.click(true)}}},[_c('div',{staticClass:"bar1"}),_c('div',{staticClass:"bar2"}),_c('div',{staticClass:"bar3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }